import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client.ts'
import type { LicenceContactT } from '@/lib/licence/licence.ts'

export const licenceContactQuery = () => ({
  queryKey: ['licenceContact'],
  queryFn: async (): Promise<LicenceContactT> => {
    const res = await api.get<{ contactEmail?: string | null; contactPhone?: string | null }>(
      '/app_settings/contact',
    )
    return { email: res.data.contactEmail ?? null, phone: res.data.contactPhone ?? null }
  },
  staleTime: 1000 * 60 * 60,
})

/** The contact shown in licence messages (GET /app_settings/contact), fetched on demand. */
export function useLicenceContact(enabled: boolean) {
  return useQuery({ ...licenceContactQuery(), enabled, throwOnError: false })
}
